import { AllocationPhaseUpdate } from '../Timeline.types';

export function useCreateAllocationUpdateRequestPhases(phases: AllocationPhaseUpdate[]) {
    function createRequestPhases() {
        let dayOffsetCount = 0;
        // TODO this mapping with increasing dayOffsetCount seems a bit ugly and difficult to read
        const remainingPhases = phases
            .filter((phase) => phase.cellSpanBefore + phase.cellSpan + phase.cellSpanAfter > 0)
            .map((phase) => {
                const newStartDateTime = phase.startDateTime.minus({ days: phase.cellSpanBefore });
                const totalDays = phase.cellSpanBefore + phase.cellSpan + phase.cellSpanAfter;
                const phaseObject = {
                    ...phase,
                    startDateTime: newStartDateTime,
                    endDateTime: newStartDateTime.plus({ days: totalDays }),
                    dayOffsetCount,
                };
                dayOffsetCount = dayOffsetCount + phase.cellSpanBefore + phase.cellSpan + phase.cellSpanAfter;
                return phaseObject;
            });

        const phasesToCreate = remainingPhases
            .filter((phase) => phase.id.startsWith('temporary-new-phase'))
            .map((phase) => ({
                duration: {
                    days: phase.cellSpanBefore + phase.cellSpan + phase.cellSpanAfter,
                    hours: 0,
                    minutes: 0,
                    months: 0,
                    seconds: 0,
                    years: 0,
                },
                offset: { days: phase.dayOffsetCount, hours: 0, minutes: 0, months: 0, seconds: 0, years: 0 },
                usageId: phase.usage.id,
                specializationType: phase.specialization ?? '',
            }));

        const updatePhases = remainingPhases.filter((phase) => !phase.id.startsWith('temporary-new-phase'));
        const phasesToUpdate = updatePhases.map((phase) => ({
            id: phase.id,
            patch: {
                duration: {
                    days: phase.cellSpanBefore + phase.cellSpan + phase.cellSpanAfter,
                    hours: 0,
                    minutes: 0,
                    months: 0,
                    seconds: 0,
                    years: 0,
                },
                offset: {
                    days: phase.dayOffsetCount,
                    hours: 0,
                    minutes: 0,
                    months: 0,
                    seconds: 0,
                    years: 0,
                },
                usageId: phase.usage.id,
                specializationType:
                    phase.newSpecialization !== phase.specialization
                        ? phase.newSpecialization
                        : (phase.specialization ?? ''),
            },
        }));
        const phasesToDelete = phases
            .filter((phase) => phase.cellSpanBefore + phase.cellSpan + phase.cellSpanAfter <= 0)
            .map((phase) => ({
                id: phase.id,
            }));
        return {
            phasesToCreate,
            updatePhases,
            phasesToUpdate,
            phasesToDelete,
            remainingPhases,
        };
    }

    return {
        createRequestPhases,
    };
}
